const commentCount = '.Social-share__link--comment-count';

function softScrollToComments() {
  $(commentCount).on('click', function (e) {
    e.preventDefault();

    const $el = $(this);
    const id = $el.data('id');
    const comments = document.getElementById('ifragasatt-article' + id);

    comments.scrollIntoView({
        behavior: 'smooth',
    });
  });
}

function getNoOfComments() {
  $(commentCount).each(function() {
    const $el = $(this);

    if ($el.data('counted')) {
      return;
    }

    $.ajax({
      type: 'POST',
      url: window.fpgmedia_js_params ? window.fpgmedia_js_params.ajaxurl : '/wp-admin/admin-ajax.php',
      data: {
        action: 'comment_count',
        postId: $el.data('id'),
      },
      success: function(response) {
        $el.find('#comment-count').text(response.data);
        $el.data('counted', true);
      },
      error: function() {
        $el.remove();
      },
    });
  });
}

export default function() {
  softScrollToComments();
  getNoOfComments();
  $(window).on('fpgmedia:post_loaded', getNoOfComments);
  $(window).on('fpgmedia:post_loaded', softScrollToComments);
}






// WEBPACK FOOTER //
// ./scripts/components/comment-count.js